import { EventBus } from 'core-components/classes/events/Bus'
import { IForm } from 'core-components/classes/models/IForm'

import { TSubscriberFn } from './types'

enum SubscribeEvents {
  change = 'change',
}

export class BaseFetcher<T = IForm> {
  private fetcherEventBus: EventBus = new EventBus([SubscribeEvents.change], 'Static')

  public subscribersCall(data: T[] | boolean) {
    this.fetcherEventBus.notify(SubscribeEvents.change, data)
  }

  public subscribe(event: string, callBack: TSubscriberFn<T>) {
    if (event === SubscribeEvents.change) {
      return this.fetcherEventBus.subscribe(SubscribeEvents.change, (event, data) => {
        callBack(data)
      })
    }
    return
  }

  public abort(): void {}

  public clone(): any {
    throw new Error('AbstractFetcher: Method must be implemented')
  }

  protected getMessageFromError = (e: unknown): string => {
    return e instanceof Error ? e.message : ''
  }
}
